import React from 'react';

const Logo = ({ size = 'default', showSubtitle = true, className = '' }) => {
  const sizes = {
    small: {
      logo: 48,
      text: 'text-lg',
      subtitle: 'text-[7px]',
      gap: 'gap-2'
    },
    default: {
      logo: 60,
      text: 'text-xl',
      subtitle: 'text-[9px]',
      gap: 'gap-3'
    },
    large: {
      logo: 76,
      text: 'text-2xl',
      subtitle: 'text-[10px]',
      gap: 'gap-3'
    }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center ${s.gap} ${className}`}>
      <div 
        className="logo-icon-wrapper flex-shrink-0"
        style={{ width: s.logo, height: s.logo }}
      >
        <img
          src="/logo-icon.png"
          alt="ICARDETAIL"
          width={s.logo}
          height={s.logo}
          className="logo-icon-img"
          style={{ 
            width: s.logo, 
            height: s.logo, 
            objectFit: 'contain',
          }}
        />
      </div>
      
      <div className="flex flex-col leading-none gap-0.5">
        <span 
          className={`${s.text} font-extrabold tracking-tight logo-shimmer`}
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          ICARDET<span className="text-red-600">AI</span>L
        </span>
        {showSubtitle && (
          <span className={`${s.subtitle} uppercase tracking-[0.2em] text-zinc-400 font-medium`}>
            Automóveis
          </span>
        )}
      </div>
    </div>
  );
};

export const LogoIcon = ({ size = 48, className = '' }) => (
  <img
    src="/logo-icon.png"
    alt="ICARDETAIL"
    width={size}
    height={size}
    className={className}
    style={{ 
      width: size, 
      height: size, 
      objectFit: 'contain',
    }}
  />
);

export default Logo;
